import { useState } from "react";

import { Plan } from "api/plan-change";

export type SelectedPlan = {
  planId: string;
  plan: Plan;
  isAnnual: boolean;
};

export const emptySelectedPlan: SelectedPlan = {
  planId: "",
  isAnnual: false,
  plan: {
    _id: "",
    active: false,
    currentPlan: false,
    displayName: "",
    displayPrice: 0,
    igIncluded: 0,
    igIncludedUpTo: 0,
    otherIncludedUpTo: 0,
    otherIncluded: 0,
    price: { usd: 0, aud: 0, eur: 0, gbp: 0 },
    primaryCbId: { monthly: "", annual: "" },
    secondaryCbIds: [],
    tooManyAccounts: false,
  },
};

export function useSelectedPlan() {
  const [selectedPlan, setSelectedPlan] = useState(emptySelectedPlan);

  return {
    selectedPlan,
    selectPlan: setSelectedPlan,
  };
}
